import { initFilterSelects } from './modules/tom-select-utils';
import { on } from './utils/events';

// Filter chips (roles, contacts): a chip with a checked input inside is active
const CHIPS = '.filter-role, .filter-soc';

function setChip(chip, active) {
    chip.classList.toggle('active', active);
    chip.querySelectorAll('input').forEach((input) => input.checked = active);
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(CHIPS).forEach(function (chip) {
        if (chip.querySelector('input:checked')) chip.classList.add('active');
    });
    initFilterSelects();

    on('click', '.btn-search', function (ev, button) {
        ev.preventDefault();

        const form = button.closest('form');
        const value = (name) => form.querySelector(`[name="${name}"]`)?.value || '';
        const values = (selector) => [...form.querySelectorAll(selector)].map((el) => el.value).join('-or-');

        // URL segments in this order: /region/euw/rank/gold/role/top-or-mid/...
        const filters = [
            ['region', value('region')],
            ['rank', value('rank')],
            ['role', values('[name^="role"]:checked')],
            ['contacts', values('[name^="contacts"]:checked')],
            ['goal', value('goal').toLowerCase()],
            ['age', value('age')],
            ['time', value('time')],
            ['voice', value('voice')],
            ['languages', values('[name="languages[]"] option:checked')],
        ];

        const query = filters.filter(([, val]) => val.length > 0).map(([key, val]) => key + '/' + val).join('/');
        const action = form.getAttribute('action');
        // Don't append a stray "/" when no filters are selected — that produces
        // /parties/ which redirects away from the current origin under some
        // proxies and breaks navigation.
        const target = query ? action + '/' + query : action;

        window.location.replace(target);
    });

    on('click', CHIPS, function (ev, chip) {
        ev.preventDefault();
        setChip(chip, !chip.classList.contains('active'));
    });

    // Reset filter button (visual only, no navigation)
    on('click', '.btn-reset', function (ev, button) {
        ev.preventDefault();
        const form = button.closest('form');

        form.querySelectorAll('select.filter-select').forEach(function (select) {
            select.tomselect?.setValue('', true);
        });

        form.querySelectorAll(CHIPS).forEach((chip) => setChip(chip, false));
    });
});
